/**
 * Typed client for the `/api/v1` REST surface.
 *
 * Grouped by resource so call sites read as `api.auth.login(...)` /
 * `api.channels.listMessages(...)`.
 */
import * as admin from './admin.js';
import * as auth from './auth.js';
import * as channels from './channels.js';
import * as files from './files.js';
import * as push from './push.js';
import * as settings from './settings.js';
import * as users from './users.js';

export const api = { admin, auth, channels, files, push, settings, users };

export {
  API_BASE_URL,
  onSessionRefreshed,
  refreshSession,
  request,
  type RefreshOutcome,
} from './client.js';
export * from './errors.js';
